import React from 'react'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'

function Breadcrumbs(props) {
  return (
    <div className="py-2">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
          <li className="breadcrumb-item"><Link to="/"><FontAwesomeIcon icon={faHome} /></Link></li>
          {props.breadcrumbs.map((val, k) => {
            return <li key={k} className="breadcrumb-item"><Link to={val.link}>{val.name}</Link></li>
          })}
          <li className="breadcrumb-item active" aria-current="page">{props.breadcrumbsCurrentPage}</li>
        </ol>
      </nav>
    </div>
  );
}

export default Breadcrumbs;
